import { AxiosResponse } from 'axios'
import { NMedia } from '../interfaces/services/media.interfaces'
import { createUrl } from './helpers'
import axiosAuth from './config'

export const createMedia = (
  mediaType: 'image' | 'video',
  data: string,
  isPublic?: boolean
): Promise<AxiosResponse<NMedia.NCreate.IResponse>> => {
  const body: NMedia.NCreate.IRequestBody = {
    cat: mediaType,
    data,
    public: isPublic,
  }
  return axiosAuth.post<NMedia.NCreate.IResponse>(
    createUrl('/media/media'),
    body
  )
}

export const deleteMedia = (
  id: string
): Promise<AxiosResponse<NMedia.NDel.IResponse>> => {
  return axiosAuth.delete<NMedia.NDel.IResponse>(
    createUrl(`/media/media/${id}`)
  )
}
